import { z } from "zod";
import { uuid } from "../_common.js";

/**
 * `ai.askYourBusiness` — system-decisions §5. AI narrates, code computes.
 *
 * Cross-tenant safety enforced at the connection layer (architecture §4.2 RLS).
 * Hard query timeout 5 seconds, row cap 10,000 (system-decisions §5).
 */
export const askInput = z.object({
  q: z.string().min(1).max(280),
});

export const askOutput = z.object({
  answerMarkdown: z.string(),
  /** Show-me-the-data link — required by system-decisions §5. */
  showData: z.object({
    sql: z.string(),
    rowCount: z.number().int().nonnegative(),
  }),
  meta: z.object({
    model: z.string(),
    modelVersion: z.string(),
    confidence: z.number().min(0).max(1),
    promptId: uuid,
    costPaise: z.string(),
  }),
});

/**
 * `ai.whyBehind` — narrative explainer for any number on the dashboard.
 * Architecture §3 — domain/ai/narrators owns the prompt.
 */
export const whyBehindInput = z.object({
  metric: z.enum(["cash", "receivables", "overdue", "compliance", "health-score"]),
  /** Optional drill — e.g. focus on a customer or invoice. */
  filter: z.record(z.string()).optional(),
});

export const whyBehindOutput = z.object({
  storyMarkdown: z.string(),
  steps: z.array(
    z.object({
      label: z.string(),
      detail: z.string(),
      sourceEntity: z
        .object({
          type: z.string(),
          id: uuid,
        })
        .optional(),
    }),
  ),
  meta: z.object({
    model: z.string(),
    modelVersion: z.string(),
    confidence: z.number().min(0).max(1),
  }),
});
